import { ISubscriptionsProlongCurrentSubscriptionResponse } from '../../../repositories/billing-subscriptions/v2/subscriptions-prolong-current-subscription';
import { IProlongSubscriptionSuccess } from '../types';
import { EBuyPackageStatus } from '../../../types';
import { defaultTo } from 'ramda';
import { capitalize } from '../../../utils/string';

export const mapResponse200 = (
  response: ISubscriptionsProlongCurrentSubscriptionResponse,
): IProlongSubscriptionSuccess => {
  const { messages } = response;

  const status = defaultTo('', response.status);

  return {
    isSuccess: true,
    code: capitalize(status) as string as EBuyPackageStatus,
    message: defaultTo('', messages?.[0]),
  };
};
